import { Composition, Still } from "remotion";
import { Fragment } from "react";
import { videoRegistry } from "./videos/registry";
import { HelloWorld, myCompSchema } from "./HelloWorld";
import { Logo, myCompSchema2 } from "./HelloWorld/Logo";
import { EAKCArchitecture } from "./EAKCArchitecture";
import {
  TOTAL_DURATION,
  FPS,
  WIDTH,
  HEIGHT,
} from "./EAKCArchitecture/constants";
import { EAKCRagDeepDive } from "./EAKCRagDeepDive";
import {
  TOTAL_DURATION as RAG_DURATION,
  FPS as RAG_FPS,
  WIDTH as RAG_WIDTH,
  HEIGHT as RAG_HEIGHT,
} from "./EAKCRagDeepDive/constants";
import { EAKCProductVideo } from "./EAKCProductVideo";
import {
  TOTAL_DURATION as PROD_DURATION,
  FPS as PROD_FPS,
  WIDTH as PROD_WIDTH,
  HEIGHT as PROD_HEIGHT,
} from "./EAKCProductVideo/constants";
import { EAKCVisionRoadmap } from "./EAKCVisionRoadmap";
import {
  TOTAL_DURATION as VISION_DURATION,
  FPS as VISION_FPS,
  WIDTH as VISION_WIDTH,
  HEIGHT as VISION_HEIGHT,
} from "./EAKCVisionRoadmap/constants";
import { EAKCMemoryLoop } from "./EAKCMemoryLoop";
import {
  TOTAL_DURATION as MEM_DURATION,
  FPS as MEM_FPS,
  WIDTH as MEM_WIDTH,
  HEIGHT as MEM_HEIGHT,
} from "./EAKCMemoryLoop/constants";
import { EAKCMarketBrief } from "./EAKCMarketBrief";
import {
  TOTAL_DURATION as MB_DURATION,
  FPS as MB_FPS,
  WIDTH as MB_WIDTH,
  HEIGHT as MB_HEIGHT,
} from "./EAKCMarketBrief/constants";
import { EAKCProductDemo } from "./EAKCProductDemo";
import {
  TOTAL_DURATION as PD_DURATION,
  FPS as PD_FPS,
  WIDTH as PD_WIDTH,
  HEIGHT as PD_HEIGHT,
} from "./EAKCProductDemo/constants";
import { EAKC30SecDemo } from "./EAKC30SecDemo";
import {
  TOTAL_DURATION as D30_DURATION,
  FPS as D30_FPS,
  WIDTH as D30_WIDTH,
  HEIGHT as D30_HEIGHT,
} from "./EAKC30SecDemo/constants";
import { EAKCSecurity } from "./EAKCSecurity";
import {
  TOTAL_DURATION as SEC_DURATION,
  FPS as SEC_FPS,
  WIDTH as SEC_WIDTH,
  HEIGHT as SEC_HEIGHT,
} from "./EAKCSecurity/constants";
import { HermesEAKC } from "./HermesEAKC";
import {
  TOTAL_DURATION as HERMES_DURATION,
  FPS as HERMES_FPS,
  WIDTH as HERMES_WIDTH,
  HEIGHT as HERMES_HEIGHT,
} from "./HermesEAKC/constants";
import { EAKCMultiTenantRLS } from "./EAKCMultiTenantRLS";
import {
  TOTAL_DURATION as RLS_DURATION,
  FPS as RLS_FPS,
  WIDTH as RLS_WIDTH,
  HEIGHT as RLS_HEIGHT,
} from "./EAKCMultiTenantRLS/constants";
import { EAKCTwoWeeks } from "./EAKCTwoWeeks";
import {
  TOTAL_DURATION as TW_DURATION,
  FPS as TW_FPS,
  WIDTH as TW_WIDTH,
  HEIGHT as TW_HEIGHT,
} from "./EAKCTwoWeeks/constants";

// Each <Composition> is an entry in the sidebar!

export const RemotionRoot: React.FC = () => {
  return (
    <>
      {/* ── EAKC YouTube series · Cold Compute/Neon (2026) · all 24 in PUBLISH ORDER (src/videos/registry) ── */}
      {videoRegistry.map((v) => (
        <Fragment key={v.id}>
          <Composition
            id={v.id}
            component={v.component}
            durationInFrames={v.duration}
            fps={30}
            width={1920}
            height={1080}
          />
          <Still
            id={`${v.id}Thumb`}
            component={v.thumb}
            width={1280}
            height={720}
          />
        </Fragment>
      ))}

      {/* EAKC — Two Weeks of Building a Self-Learning AI Knowledge Companion · 80 slides ~22min · 02 Jun 2026 */}
      <Composition
        id="EAKCTwoWeeks"
        component={EAKCTwoWeeks}
        durationInFrames={TW_DURATION}
        fps={TW_FPS}
        width={TW_WIDTH}
        height={TW_HEIGHT}
      />

      {/* Explainer Series Ep1: Multi-Tenant Data Isolation with RLS (mission 6fc051db) */}
      <Composition
        id="EAKCMultiTenantRLS"
        component={EAKCMultiTenantRLS}
        durationInFrames={RLS_DURATION}
        fps={RLS_FPS}
        width={RLS_WIDTH}
        height={RLS_HEIGHT}
      />

      {/* Building Hermes-Inspired Capabilities into EAKC - 30 slides - 24 May 2026 */}
      <Composition
        id="HermesEAKC"
        component={HermesEAKC}
        durationInFrames={HERMES_DURATION}
        fps={HERMES_FPS}
        width={HERMES_WIDTH}
        height={HERMES_HEIGHT}
      />

      {/* EAKC Security Deep-Dive - 18 slides 300s */}
      <Composition
        id="EAKCSecurity"
        component={EAKCSecurity}
        durationInFrames={SEC_DURATION}
        fps={SEC_FPS}
        width={SEC_WIDTH}
        height={SEC_HEIGHT}
      />

      {/* EAKC 30-Second Demo - hook teaser 45s */}
      <Composition
        id="EAKC30SecDemo"
        component={EAKC30SecDemo}
        durationInFrames={D30_DURATION}
        fps={D30_FPS}
        width={D30_WIDTH}
        height={D30_HEIGHT}
      />

      {/* EAKC Product Demo - OBS scaffolding 228s */}
      <Composition
        id="EAKCProductDemo"
        component={EAKCProductDemo}
        durationInFrames={PD_DURATION}
        fps={PD_FPS}
        width={PD_WIDTH}
        height={PD_HEIGHT}
      />

      {/* EAKC Market Brief - Stakeholder problems 240s */}
      <Composition
        id="EAKCMarketBrief"
        component={EAKCMarketBrief}
        durationInFrames={MB_DURATION}
        fps={MB_FPS}
        width={MB_WIDTH}
        height={MB_HEIGHT}
      />

      {/* EAKC Platform Vision and Roadmap - 158s */}
      <Composition
        id="EAKCVisionRoadmap"
        component={EAKCVisionRoadmap}
        durationInFrames={VISION_DURATION}
        fps={VISION_FPS}
        width={VISION_WIDTH}
        height={VISION_HEIGHT}
      />

      {/* EAKC Product Video - 5:30 */}
      <Composition
        id="EAKCProductVideo"
        component={EAKCProductVideo}
        durationInFrames={PROD_DURATION}
        fps={PROD_FPS}
        width={PROD_WIDTH}
        height={PROD_HEIGHT}
      />

      {/* Ep1: EAKC System Architecture Explainer - 60s */}
      <Composition
        id="EAKCArchitecture"
        component={EAKCArchitecture}
        durationInFrames={TOTAL_DURATION}
        fps={FPS}
        width={WIDTH}
        height={HEIGHT}
      />

      {/* Ep2: RAG Pipeline Deep Dive - 60s */}
      <Composition
        id="EAKCRagDeepDive"
        component={EAKCRagDeepDive}
        durationInFrames={RAG_DURATION}
        fps={RAG_FPS}
        width={RAG_WIDTH}
        height={RAG_HEIGHT}
      />

      <Composition
        id="EAKCMemoryLoop"
        component={EAKCMemoryLoop}
        durationInFrames={MEM_DURATION}
        fps={MEM_FPS}
        width={MEM_WIDTH}
        height={MEM_HEIGHT}
      />

      <Composition
        id="HelloWorld"
        component={HelloWorld}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        schema={myCompSchema}
        defaultProps={{
          titleText: "Welcome to Remotion",
          titleColor: "#000000",
          logoColor1: "#91EAE4",
          logoColor2: "#86A8E7",
        }}
      />

      <Composition
        id="OnlyLogo"
        component={Logo}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        schema={myCompSchema2}
        defaultProps={{
          logoColor1: "#91dAE2" as const,
          logoColor2: "#86A8E7" as const,
        }}
      />
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
